import {authBearer,portalApiGet} from '@/lib/portal-api';
import {getSupabaseBrowserClient} from '@/lib/supabase';

/** Captured credentials are memory-only and never put in operation storage. */
export async function moneyOperationSession(kind:string) {
 const bearer=await authBearer();
 if(!bearer)throw new Error('Sign in before continuing.');
 const client=getSupabaseBrowserClient();
 let actor=(await client?.auth.getSession())?.data.session?.user.id??null;
 if(!actor && !client && import.meta.env.DEV)actor=Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256',new TextEncoder().encode(bearer))),b=>b.toString(16).padStart(2,'0')).join('');
 if(!actor)throw new Error('Your session identity is unavailable.');
 const me=await portalApiGet<{organizationId:number;role:string;clinicIds:readonly number[]}>('/dashboard/me',bearer);
 if(await authBearer()!==bearer)throw new Error('Your session changed. Reopen the saved operation.');
 if(!Number.isSafeInteger(me.organizationId)||!Array.isArray(me.clinicIds))throw new Error('Your money scope is unavailable.');
 const prefix=`money-${kind}-operation:${actor}:`;
 const scopeKey=JSON.stringify([me.organizationId,me.role,[...me.clinicIds].sort((a,b)=>a-b)]);
 const key=prefix+scopeKey;
 for(let i=0;i<sessionStorage.length;i++) {
  const other=sessionStorage.key(i);
  if(kind!=='draft'&&other?.startsWith(prefix)&&other!==key&&!other.startsWith(key+':')&&sessionStorage.getItem(other))throw new Error('An unconfirmed operation belongs to another scope. Restore that scope to resolve it.');
 }
 return {key,bearer,actor,scopeKey,organizationId:me.organizationId,async assertCurrent() {
  const current=await moneyOperationSession(kind);
  if(current.key!==key||current.bearer!==bearer)throw new Error('Your session changed. Reopen the saved operation in its original session.');
 }};
}
